import React from 'react';
import { Box } from '@mui/material';

import type { CcMetrics } from 'hooks/swrRequests/useAdminCcMetrics';
import StatCard from './stat-card';

// The 4 all-time dashboard stat cards. `—` until metrics load.
const StatsRow: React.FC<{ metrics: CcMetrics | null }> = ({ metrics }) => (
  <Box display="flex" flexWrap="wrap" gap={2} marginBottom={3.5}>
    <StatCard label="Total requests" value={metrics?.totalRequests ?? '—'} />
    <StatCard label="Auto-matched" value={metrics?.autoMatches ?? '—'} />
    <StatCard label="Team matched" value={metrics?.teamMatches ?? '—'} />
    <StatCard label="Connected" value={metrics?.totalMatches ?? '—'} />
  </Box>
);

export default StatsRow;
